import axios from "axios";

// Automatically determine backend URL based on current host
const getBackendUrl = () => {
  const currentHost = window.location.hostname;
  
  // If accessing via IP address (mobile testing), use same IP for backend
  if (currentHost.match(/^\d+\.\d+\.\d+\.\d+$/)) {
    return `http://${currentHost}:5000`;
  }
  
  // Default to localhost for desktop development
  return process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
};

const api = axios.create({
  baseURL: getBackendUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Never send FormData with a JSON Content-Type.
 *
 * The default above applies to every request, and axios 1.x reacts to a JSON
 * content type by running transformRequest -> formDataToJSON: the FormData is
 * serialised to JSON and every File in it becomes `{}`. The upload is destroyed
 * in the browser, before the request is even sent, and nothing warns you --
 * the server just reports the file as missing, so the bug looks like it is on
 * the server side. Warrant returns rejected a plainly-attached ownership CSV
 * that way, and the body on the wire was {"source":"agol","ownership_file":{}}.
 *
 * Clearing the header lets the browser set multipart/form-data with a boundary.
 * Cards that pass an explicit multipart header still work -- axios replaces it
 * with a boundary-bearing one either way -- so this makes the header optional
 * rather than load-bearing, and a new upload card cannot inherit the trap.
 */
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers.delete("Content-Type");
  }
  return config;
});

console.log("API Base URL:", api.defaults.baseURL);

export default api;
